import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Loader from '../../components/Loader';
import axios from 'axios';
import params from '../../config/Params';
import { getItemFromLocalStorage } from '../../utils/storageUtils';
import { toast } from 'react-toastify';

const PayoutIndex = () => {

  const [loading, setLoading] = useState(true);
  const [myMethods, setMyMethods] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);

  useEffect(() => {
    const fetchBaseData = async () => {
        const hostData = getItemFromLocalStorage('hostProfile');
        let formData = new FormData();
        formData.append('token', hostData.host_access_token);

        try {
            const response = await axios({
                method: 'post',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                url: `${params.baseURL}${params.endpoints.payoutMyMethods}`,
                data: formData
            });

            if (response.data.items && Array.isArray(response.data.items)) {
                setMyMethods(response.data.items);
                setLoading(false);
            } else {
                toast.error('An error occurred while fetching payout methods.');
            }
        } catch (err) {
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    fetchBaseData();
  }, []);

  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
      question: "Where does it come from?",
      answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
      return <Loader />;
  }

  return (
    <div>
      <Helmet>
        <title>Payout Setup</title>
        <meta name='description' content='' />
      </Helmet>

      <div className='row'>
        <div className='col-md-7'>
          <div className="payout-setup">
            <h4>Ensure Smooth Payouts</h4>
            <p>Complete your account setup to get paid for your bookings.</p>

            <div className="ps-btn-box">
                <a href="/payouts/add-payout-option/" className="co-host-box" style={{width: 'auto', alignContent: 'center'}}>Add payout method</a>
            </div>
          </div>

          <div className="payout-methods">
            {myMethods.length === 0 ? (
              <></>
            ) : (
              myMethods.map((method, index) => (
                <div key={index} className="payout-mymethod-box">
                  <p className='pmms-mn'>{method.method_name}</p>
                  <p className='pmms-vst'>{method.verification_status_text}</p>
                  <p className='pmms-ai'>{method.account_info}</p>
                </div>
              ))
            )}
          </div>
        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
              <div className='blog-box'>
                  <div class="blog">
                      <div class="blog-image">
                          <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                          <div class="date">May 08, 2025</div>
                      </div>
                      <div class="blog-content">
                          <h2>What is Lorem Ipsum?</h2>
                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                          <a href="#">Read More</a>
                      </div>
                  </div>
              </div>
              <div className="faq-sticky">
                  {faqs.map((faq, index) => (
                  <div key={index} className='faqs-list-section'>
                      <div
                      onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                      style={{
                          backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                      }}
                      >
                      {faq.question}
                      <i
                          className={`fas ${
                          activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                          }`}
                          style={{
                          transition: "transform 0.3s ease",
                          }}
                      ></i>
                      </div>
                      {activeIndex === index && (
                      <div className='faqs-ans-box'>
                          {faq.answer}
                      </div>
                      )}
                  </div>
                  ))}
              </div>
          </div>
        </div>

      </div>

    </div>
  );
};

export default PayoutIndex;
